import api from '@/api';

import { ImportedCpfCnpjResponse } from './ImportedCPFCNPJ.types';
import { API_BASE_URL } from '..';

const baseUrl = `${API_BASE_URL}/imported-cpf-cnpj`;

export async function importedCpfCnpj(cpfcnpj: string) {
  const result = (await api.get(`${baseUrl}/${cpfcnpj}`, {})) as unknown;

  return result as ImportedCpfCnpjResponse;
}
